module.exports = __webpack_public_path__ + "static/cosmicguard.com/img/compare_traffic_games.6f09ff22.png";